var map = {
	"./authorize-net-integration.png": "4477",
	"./authorize.net-integration.png": "edb6",
	"./braintree-integration.png": "e8ab",
	"./groove_pay-integration.png": "827b",
	"./groovepay-integration.png": "1324",
	"./groovepay_automated-integration.png": "29cd",
	"./groovepaybr-integration.png": "d257",
	"./mollie-integration.png": "5288",
	"./nmi-integration.png": "33e7",
	"./paypal-integration.png": "8846",
	"./paypal_commerce-integration.png": "375f",
	"./paystack-integration.png": "fc1d",
	"./spreedly-integration.png": "a466",
	"./stax-integration.png": "5b4a",
	"./stripe-integration.png": "47cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57f6";